import { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { Image, ViewLock, ContentText, ViewCommentNotification } from "./style";
import THEME from "../../config/theme";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { SmallText, FooterText } from "../../config/theme/globalStyles";
import { View, Pressable, StyleSheet } from "react-native";
import Svg, { Path } from 'react-native-svg';
import { useCustomTheme } from '../../contexts/useCustomTheme';
import { openClassOrLinkContent } from '../../utils/openLinkContent';
import { ADMIN_FONT } from '../../config/theme/adminColors';

// `system-ui` não carrega peso no nome da família (diferente de `text_Medium`),
// então o destaque do selo vem do fontWeight.
const adminBadgeText = { fontFamily: ADMIN_FONT, fontWeight: '600' };

// TEMP: oculta selos Publicado/Arquivado nas capas para prints — reverter depois.
const HIDE_ADMIN_COVER_STATUS_BADGE = true;

const CategoryItem = ({
  categoryId,
  item,
  user,
  orientation,
  selectedFilter,
  onPressItem,
  productCatalogOrigin,
}) => {
  const navigation = useNavigation();

  const onCardPress = () => {
    if (onPressItem) {
      onPressItem();
    }

    if (!item?.videoId) {
      navigation.navigate({
        name: "Modulo",
        params: {
          cardId: item.id ? item.id : item.cardId,
          categoryId: categoryId ? categoryId : item.categoryId,
          ...(user?.firstPlanPurchase && { firstPlanPurchase: user?.firstPlanPurchase }, user?.isAdmin && { orientation: orientation }),
          scrollPosition: window?.scrollY || 0,
          selectedFilter,
          // Aberto a partir da vitrine de produtos: o botão "Voltar" do Módulo
          // precisa retornar pra cá, não pra Main (ver ClickCard).
          ...(productCatalogOrigin && { productCatalogOrigin }),
        },
        // merge: true — defensivo: se "Modulo"/"Aula" já estiver na pilha (ex.:
        // reabrindo o mesmo módulo), não some com o productCatalogOrigin que
        // essa rota já tinha por causa de um payload sem essa chave.
        merge: true,
      });
    } else if (item?.videoId) {
      void openClassOrLinkContent({
        item,
        webUrl: customInfo?.webUrl,
        categoryId: item.categoryId,
        cardId: item.cardId,
        videoId: item.videoId,
        onOpenClass: () => {
          navigation.navigate({
            name: 'Aula',
            params: {
              cardId: item.cardId,
              categoryId: item.categoryId,
              selectedVideo: item.videoId,
              scrollPosition: window?.scrollY || 0,
              selectedFilter,
              ...(productCatalogOrigin && { productCatalogOrigin }),
            },
            merge: true,
          });
        },
      });
    }
  };

  const toDate = (seconds) => {
    const date = new Date(1970, 0, 1);
    date.setSeconds(seconds);
    return date;
  };

  const { customColor, customFont, customInfo } = useCustomTheme();

  const [hovered, setHovered] = useState(false);

  const baseTitleSize = customFont?.fontXS || THEME.FONTSIZE.EXTRASMALL;

  const horizontalImage = item?.backgroundImage?.url || item?.img;
  const verticalImage = item?.backgroundImage?.urlVertical;

  const imageUri =
    orientation === 'vertical' && verticalImage
      ? verticalImage
      : horizontalImage;

  return (
    <Pressable
      onPress={onCardPress}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={[styles.card, hovered && styles.cardHovered]}
    >
      <Image
        source={{ uri: imageUri }}
        orientation={orientation || 'horizontal'}
        style={[styles.imageBase, hovered && styles.imageHover]}
      >
        {/* Selo de status: só o admin enxerga, então usa a tipografia do painel
            (ADMIN_FONT), nunca a fonte da marca do cliente. As cores continuam
            temáticas porque o selo fica sobre a capa do próprio cliente. */}
        {!HIDE_ADMIN_COVER_STATUS_BADGE && item.archived == false && user?.isAdmin && (
          <ContentText backgroundColor="white">
            <FooterText
              margin="0rem 1rem"
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.TEXT_ABOUT
              }
              style={adminBadgeText}
            >
              {item.order}
            </FooterText>
            <FooterText color="black" style={adminBadgeText}>
              Publicado
            </FooterText>
          </ContentText>
        )}
        {!HIDE_ADMIN_COVER_STATUS_BADGE && item.archived == true && user?.isAdmin && (
          <ContentText backgroundColor="black">
            <FooterText margin="0rem 1rem" color="white" style={adminBadgeText}>
              {item.order}
            </FooterText>
            <FooterText color="white" style={adminBadgeText}>
              Arquivado
            </FooterText>
          </ContentText>
        )}
        {item.hasNewComment == true && user?.isAdmin && (
          <ViewCommentNotification>
            <MaterialCommunityIcons
              name="comment-eye"
              size={24}
              color={
                customColor && customColor.primary
                  ? customColor.primary
                  : THEME.COLORS.PRIMARY_900
              }
              style={{ padding: '0.2rem' }}
            />
          </ViewCommentNotification>
        )}
        {(item?.productIds &&
          item?.productIds?.length > 0 &&
          item?.productIds?.filter((cardProductId) => {
            const matchingUserProducts = user?.productIds?.filter(
              (userProduct) => userProduct.productId === cardProductId
            );
            if (!matchingUserProducts || matchingUserProducts.length === 0) {
              return false; // O usuário não possui este produto, então não tem acesso
            }
            // Se não houver data de expiração, ou se alguma data de expiração for maior que a data atual, o usuário tem acesso
            return matchingUserProducts.some(
              (userProduct) =>
                !userProduct.expirationDate ||
                toDate(userProduct.expirationDate.seconds) > new Date()
            );
          }).length > 0) ||
          (item?.plans &&
            item.plans?.length > 0 &&
            item.plans?.filter(
              (item) => (item.priceId || item.productId) == user?.plan
            ).length > 0) ||
          (user?.courses?.length > 0 &&
            user?.courses.filter(
              (userCourse) =>
                item.coursesCard?.some(
                  (itemToBeRemoved) =>
                    (itemToBeRemoved.priceId || itemToBeRemoved.productId) ===
                    (userCourse.priceId || userCourse.productId)
                ) && toDate(userCourse.dueDate.seconds) > new Date()
            ).length > 0) ||
          (item.plans == null &&
            item.coursesCard == null &&
            item.productIds == null) ||
          user?.isAdmin ? (
          <div></div>
        ) : (
          <ViewLock>
            <View
              style={{
                backgroundColor: 'white',
                padding: 3,
                borderRadius: 10,
              }}
            >
              <Svg width={20} height={20} viewBox="0 0 16 16" fill="none">
                <Path
                  d="M4 5.014v-.93c0-1.078.417-2.114 1.165-2.881A3.96 3.96 0 018 0a3.96 3.96 0 012.835 1.203A4.127 4.127 0 0112 4.083v.93a2.25 2.25 0 012 2.237v5.5A2.25 2.25 0 0111.75 15h-7.5A2.25 2.25 0 012 12.75v-5.5a2.25 2.25 0 012-2.236zM6.239 2.25A2.46 2.46 0 018 1.5c.657 0 1.29.267 1.761.75.471.483.739 1.142.739 1.833V5h-5v-.917c0-.69.268-1.35.739-1.833zM8 9.25a.75.75 0 00-.75.75v1a.75.75 0 001.5 0v-1A.75.75 0 008 9.25z"
                  fillRule="evenodd"
                  fill={
                    customColor &&
                      customColor.iconsMain &&
                      customColor.iconsMain.iconLock
                      ? customColor.iconsMain.iconLock
                      : THEME.COLORS.ICON
                  }
                />
              </Svg>
            </View>
          </ViewLock>
        )}
      </Image>
      <SmallText
        fontSize={baseTitleSize}
        style={{
          fontFamily:
            customFont && customFont.fontFamilyText
              ? customFont.fontFamilyText
              : THEME.FONTFAMILY.REGULAR,
          // Cresce via TRANSFORM (não reflui o layout), ancorado à esquerda,
          // então as demais categorias permanecem fixas. Mesma escala/origem
          // do card para o movimento ficar coeso.
          transformOrigin: 'left center',
          transitionDuration: '160ms',
          transitionProperty: 'transform',
          transitionTimingFunction: 'ease-out',
          transform: hovered ? [{ scale: 1.06 }] : [{ scale: 1 }],
        }}
        color={
          customColor && customColor.text && customColor.text.app
            ? customColor.text.app
            : THEME.COLORS.TEXT_MAIN
        }
        maxWidth={(orientation === 'vertical' ? '8.44rem' : '15rem')}
        textAlign="left"
        numberOfLines={2}
      >
        {/* Título oculto para o aluno quando `hideTitle` — o admin sempre vê
            (busca/filtros/acesso continuam usando o título armazenado). */}
        {user?.isAdmin ? item.title : (item.hideTitle ? '' : item.title)}
      </SmallText>
    </Pressable>
  );
};

//masWidth do SmallText é a largura do cardItem

// Efeito hover estilo Netflix (web): o CARD (imagem) dá um leve zoom com sombra
// que segue exatamente o contorno arredondado do card; o título só cresce de fonte.
const styles = StyleSheet.create({
  card: {
    cursor: 'pointer',
    position: 'relative',
  },
  cardHovered: {
    zIndex: 5,
  },
  imageBase: {
    // Ancorado à esquerda (mesma origem do título) → crescem alinhados e para
    // a direita, sem invadir o card anterior nem refluir o layout.
    transformOrigin: 'left center',
    transitionDuration: '160ms',
    transitionProperty: 'transform, box-shadow',
    transitionTimingFunction: 'ease-out',
  },
  imageHover: {
    transform: [{ scale: 1.06 }],
    // Sombra mais contida p/ caber no paddingVertical do carrossel (não corta).
    boxShadow: '0 6px 16px rgba(0,0,0,0.28)',
  },
});

export default CategoryItem;
